import { createFileRoute } from '@tanstack/react-router'
import { AddonsPage } from '@/features/addons/components/AddonsPage'

export const Route = createFileRoute('/_auth/catalog/add-ons/')({
  component: AddOnsPage,
})

function AddOnsPage() {
  return <AddonsPage />
}
